import differenceInDays from 'date-fns/differenceInDays'
import isAfter from 'date-fns/isAfter'

import { CertificationStatus } from '../constants/certificate.constant'
import { Certificate } from '../models/certificate.model'

const useCertificationState = () => {
  const isCertificationActive = (token: string, expiration: number) => {
    return !!token && !!expiration && isAfter(new Date(expiration), new Date())
  }

  const isCertificationNearExpiration = (expiration: number) => {
    const daysUntilExpiration = differenceInDays(
      new Date(expiration),
      new Date()
    )
    return daysUntilExpiration <= 1
  }

  const checkCertificationState = ({ token, expiration }: Certificate) => {
    const isActive = isCertificationActive(token, expiration)
    const isNearExpiration = isActive
      ? isCertificationNearExpiration(expiration)
      : false
    return { isActive, isNearExpiration }
  }

  const getMappedCertificationState = (certification: Certificate) => {
    const fullState = checkCertificationState(certification)
    return fullState.isNearExpiration
      ? CertificationStatus.NEAR_EXPIRATION
      : fullState.isActive
      ? CertificationStatus.ACTIVE
      : CertificationStatus.INACTIVE
  }

  return {
    checkCertificationState,
    getMappedCertificationState
  }
}

export default useCertificationState
